import React, { useEffect, useState, useRef } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import GameScreen from './game/game';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';

function Index() {
  const { i18n } = useTranslation();
  const langEng = i18n.language === 'en' ?? false;
  const { change, getInitData } = useRefresh();
  const [menus, setMenus] = useState([]);

  const scrollContainerRef = useRef(null);
  const [showListProduct, setShowListProduct] = useState(false);
  const [showSpecials, setShowSpecials] = useState(false);
  const [showGame, setShowGame] = useState(false);
  const [showHappy, setShowHappy] = useState(false);
  const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
  const [showBar, setShowBar] = useState(false);
  const [dishs, setdishs] = useState(false);
  const [dataDish, setDataDish] = useState(false);

  const [dataShushi, setdataShushi] = useState(false);
  const [shushiroll, setShushiRoll] = useState(false);
  const [showDetailProduct, setShowDetailProduct] = useState(false);
  const [dataGrill, setdataGrill] = useState(false);
  const [dataSuhsi, setdataSuhsi] = useState(false);
  const [dataChurrasco, setdataChurrasco] = useState(false);

  const [dataappetizers, setdataappetizers] = useState(false);
  const [picada, setpicada] = useState(false);

  const { goHomeInit } = useSelector((state) => state.initLoad);

  useEffect(() => {
    console.log(goHomeInit, 'q mas qlq');
    setShowListProduct(false);
    setShowSpecials(false);
    setShowHappy(false);
    SetshowExecutiveMenu(false);
    setShowBar(false);
    setShowBar(false);
    setShowGame(false);
    setShowDetailProduct(false);
    if (scrollContainerRef && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto',
      });
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [goHomeInit]);

  useEffect(() => {
    getData('menu').then((items) => {
      const data = items.value.data;

      setMenus(data);
    });
  }, [change]);

  useEffect(() => {
    menus.map((item) => {
      if (item.id === 305) {
        setShushiRoll(item);
      }

      if (item.id === 302) {
        setdataGrill(item);
      }
      if (item.id === 303) {
        setdataappetizers(item);
      }
      if (item.id === 305) {
        setdataSuhsi(item);
      }
    });
  }, [menus]);

  useEffect(() => {
    if (dataappetizers) {
      dataappetizers.menus.map((item) => {
        if (item.id === 3349) {
          setpicada(item);
        }
      });
    }
  }, [dataappetizers]);

  useEffect(() => {
    if (dataGrill) {
      dataGrill.menus.map((item) => {
        if (item.id === 4505) {
          setdataChurrasco(item);
        }
      });
    }
  }, [dataGrill]);

  useEffect(() => {
    if (shushiroll) {
      shushiroll.menus.map((item) => {
        if (item.id === 3369) {
          setdataShushi(item);
        }
      });
    }
  }, [shushiroll]);

  useEffect(() => {
    if (scrollContainerRef && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto',
      });
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        console.log('La página ha perdido el foco (está oculta).');
        setShowListProduct(false);
        setShowSpecials(false);
        setShowHappy(false);
        SetshowExecutiveMenu(false);
        setShowBar(false);
        setShowBar(false);
        setShowGame(false);
        setShowDetailProduct(false);
        getInitData();
        if (scrollContainerRef && scrollContainerRef.current) {
          scrollContainerRef.current.scrollTo({
            top: 0,
            left: 0,
            behavior: 'auto',
          });
        }
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      } else if (document.visibilityState === 'visible') {
        console.log('La página está en foco (visible).');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Limpieza del evento al desmontar el componente
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  window.onerror = function () {
    console.log('Error global detectado, recargando...');
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  };

  return (
    <LayoutContent
      showBack={false}
      showImageTop={true}
      setShowSpecials={setShowSpecials}
      setShowGame={setShowGame}
    >
      <div>
        <div
          style={{
            display: 'flex',
            width: '100%',
            marginTop: 10,
            position: 'relative',
            zIndex: 100,
          }}
        >
          <div style={{ width: '15%' }}></div>
          <div style={{ width: '85%', marginTop: -130 }}>
            <div style={{ display: 'flex' }}>
              <img
                style={{
                  width: 300,
                  height: 170,
                  objectFit: 'contain',
                  zIndex: 100,
                }}
                src={require('./assets/logo.png')}
              />
            </div>

            <img
              src={require('./assets/banner2.png')}
              onClick={() => {
                setdishs(dataSuhsi);
                setShowListProduct(true);
              }}
              autoPlay
              loop
              muted
              style={{
                marginTop: -20,
                width: '100%',
                height: 170,
                marginBottom: 30,
                objectFit: 'cover',
                borderRadius: 15,
              }}
            />

            <div
              ref={scrollContainerRef}
              style={{
                height: 450,
                position: 'relative',
                zIndex: 9999,
                overflow: 'scroll',
                marginTop: 10,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',

                  gap: 10,
                }}
              >
                {menus.map((item, key) => {
                  if (
                    ![
                      339, 387, 389, 390, 391, 393, 392, 395, 614, 615, 396,
                      399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409,
                      410, 411, 412, 414, 415, 416, 417, 419, 418, 557, 556,
                      590,
                    ].includes(item.id)
                  ) {
                    return (
                      <div
                        onClick={() => {
                          if (item.id === 343) {
                            SetshowExecutiveMenu(true);
                          } else {
                            setShowListProduct(true);
                            setdishs(item);
                          }
                        }}
                        style={{
                          width: 290,
                          height: 70,
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginBottom: 5,
                          display: 'flex',
                          backgroundColor: '#fff',
                          border: '3px solid #FEBA29',
                        }}
                      >
                        <div
                          style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            position: 'relative',
                            alignItems: 'center',
                          }}
                        >
                          <p
                            style={{
                              fontFamily: 'Watchtower',
                              fontSize: 45,
                              color: '#ED3E08',
                              textTransform: 'uppercase',
                              textAlign: 'center',
                              paddingHorizontal: 30,
                              position: 'absolute',
                            }}
                          >
                            {item.name}
                          </p>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
            <div
              onClick={() => {
                setShowHappy(true);
              }}
              style={{
                marginTop: 8,
                width: '99.5%',
                height: 70,
                justifyContent: 'center',
                alignItems: 'center',
                marginBottom: 15,
                display: 'flex',
                backgroundColor: '#ED3E08',
                border: '2px solid #FEBA29',
              }}
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  position: 'relative',
                  alignItems: 'center',
                }}
              >
                <p
                  style={{
                    fontFamily: 'Watchtower',
                    fontSize: 45,
                    color: '#fff',
                    textTransform: 'uppercase',
                    textAlign: 'center',
                    paddingHorizontal: 30,
                    position: 'absolute',
                  }}
                >
                  Drinks
                </p>
              </div>
            </div>

            <p style={{ color: 'white', fontSize: 13 }}>
              18% gratuity will be added to your bill (20% for groups or orders
              $500+) / Please inform your server if you have any allergy
            </p>

            {/* <div
                style={{
                    width: '100%',
                    alignItems: 'center',
                    
                    
                    margin: '10px auto',
                }}>
                            <video
                                onClick={() => {
                                   setDataDish({ dish: dataChurrasco, alldish: dataGrill.menus})
                                setShowDetailProduct(true)
                                }
                                }
                    src={require('./assets/banner1.mp4')}
                    autoPlay
                    loop
                    muted
                    style={{
                    width: '100%',
                    height: 170,
                    objectFit: 'contain',
                    borderRadius: 15,
                    }}
                />
            </div> */}
          </div>
        </div>
      </div>

      {showListProduct && (
        <ListProducts dishs={dishs} setShowListProduct={setShowListProduct} />
      )}

      {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
      {showGame && <GameScreen setShowListProduct={setShowGame} />}
      {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
      {showExecutiveMenu && (
        <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />
      )}
      {showBar && <BarScreen setShowBar={setShowBar} />}

      {showDetailProduct && (
        <DetailProduct
          dishMenu={dataDish}
          setShowListProduct2={setShowListProduct}
          setShowDetailProduct={setShowDetailProduct}
        />
      )}
    </LayoutContent>
  );
}

export default Index;
